import { Document } from 'mobx-document'
import { Notification } from '~/models'

export default class NotificationDocument extends Document<Notification> {

  public async performFetch(): Promise<any> {
    throw new Error("Not supported")
  }

}